import React from 'react';
import { ColHeader, ColHeaderText } from './styled';
import { Tooltip } from 'antd';

function MetricHeader({ column, helpLookup = {} }) {
  const { metricInfo, metric } = column;
  const hasHelpLookup = metric in helpLookup;
  const defaultTitle = hasHelpLookup
    ? helpLookup[metric]
    : `${metricInfo.displayName} ${metricInfo.subscript}`;

  return (
    <ColHeader>
      <Tooltip placement="top" title={defaultTitle}>
        <ColHeaderText>{column.title}</ColHeaderText>
      </Tooltip>
    </ColHeader>
  );
}

export default MetricHeader;
